module.exports = __webpack_public_path__ + "static/media/home.232059f1.svg";